import { Outlet } from "react-router-dom";
import "../pages/Auth/Auth.css";

export default function AuthLayout() {
  return (
    <div className="auth-layout">
      <Outlet />
    </div>
  );
}
